import React  from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import TreeViewItem from './TreeViewItem'
import BasicLeafNodeRenderer from './BasicLeafNodeRenderer'
import BasicFolderNodeRenderer from './BasicFolderNodeRenderer'
import BasicEmptyNodeRenderer from './BasicEmptyNodeRenderer'
import styles from './Tree.css'

const noOp = () => {}

export default class Tree extends React.Component {
  static propTypes = {
    nodes: PropTypes.array,
    leafComponent: PropTypes.func,
    folderComponent: PropTypes.func,
    emptyComponent: PropTypes.func,
    getName: PropTypes.func,
    getChildren: PropTypes.func,
    getExpanded: PropTypes.func,
    maxDepth: PropTypes.number,
    onClick: PropTypes.func,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
  }
  static defaultProps = {
    nodes: [],
    getExpanded: (node) => {
      // if we return a non-boolean value we are telling the tree
      // that the node is not a folder.
      if ('expanded' in node) {
        return !!node.expanded
      }
      if (node.children) return false
    },
    getName: (node) => node.name,
    getChildren: (node) => node.children,
    onClick: noOp,
    leafComponent: BasicLeafNodeRenderer,
    folderComponent: BasicFolderNodeRenderer,
    emptyComponent: BasicEmptyNodeRenderer,
    maxDepth: 10,
    itemClassName: null,
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      nodes: props.nodes,
    }
  }
  handleClick = node => {
    const nodes = this.state.nodes.slice()

    // if node has `collapsable` false. It will not be closable
    if (node && node.collapsable === false) {
      this.props.onClick(node)
      return false
    }
    if (nodes.indexOf(node) > -1 && node.hasOwnProperty('children')) {
      nodes[nodes.indexOf(node)].expanded = !nodes[nodes.indexOf(node)].expanded
      this.setState({nodes})
    }
    this.props.onClick(node)
  }
  render() {
    const {
      className,
      leafComponent,
      folderComponent,
      emptyComponent,
      onClick,
      getExpanded,
      getName,
      getChildren,
      maxDepth,
      itemClassName,
      nodes: RemoveFromDiv,
      ...other,
    } = this.props

    const {
      nodes,
    } = this.state

    const classes = classnames(
      styles.treeView, /* localized styles */
      className, /* user specified classnames */
    )
    return (
      <div {...other} className={classes}>
        {!!(nodes && nodes.length) && nodes.map((node, index) =>
          <TreeViewItem
            node={node}
            onClick={this.handleClick}
            leafComponent={leafComponent}
            folderComponent={folderComponent}
            emptyComponent={emptyComponent}
            key={index}
            getExpanded={getExpanded}
            getName={getName}
            getChildren={getChildren}
            maxDepth={maxDepth}
            className={itemClassName}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Tree/Tree.js